import { LastConsumptionInfo } from "views/projectInformation/ProjectCounters";
import {
  MdBattery20,
  MdBattery60,
  MdBattery90,
  MdBatteryUnknown,
  MdNetworkWifi,
  MdNetworkWifi1Bar,
  MdNetworkWifi2Bar,
  MdNetworkWifi3Bar,
  MdOutlineSignalWifiBad,
  MdPower,
  MdPowerOff,
  // MdRemoveRedEye,
} from "react-icons/md";
import { IoIosWarning } from "react-icons/io";
import { MdDeviceThermostat, MdAcUnit, MdWhatshot } from "react-icons/md";

import { Tooltip } from "@chakra-ui/react";
import { DeviceObj } from "views/counters";
import { ModuleObject } from "views/warehouse/ModuleStorage";
import { DynamicOption } from "components/fields/SelectInput";
import { convertTZ, getToday } from "./TimeUtiles";
import { UserObject } from "views/users/UsersTable";
import { ProjectObject } from "views/projects";
import { CounterStatusRenderer } from "views/settings/CounterStatus";
export const renderTags = (tagName: string) => {
  return (
    <span
      className={`${
        tagName === "آب"
          ? " bg-blue-500"
          : tagName === "برق"
          ? " bg-red-500"
          : tagName === "گاز"
          ? "bg-orange-500"
          : " bg-yellow-600"
      } rounded px-2 text-sm text-white`}
    >
      {tagName}
    </span>
  );
};

// export const renderCounterStatus = (
//   status: LastConsumptionInfo,
//   showTemper: boolean = false,
//   isMobile: boolean = false
// ) => {
//   const battery = status?.voltage_detail?.Backup || 0;
//   const signal = status?.SignalQuality || 0;
//   const backupBattery = status?.voltage_detail?.Battery || 0;
//   const temperValue = status?.temperature_detail?.MCU ?? null;

//   const getBatteryColor = (value: number) =>
//     value > 3.5
//       ? "text-yellow-400"
//       : value > 3.5
//       ? "text-green-600"
//       : value > 3.3
//       ? "text-yellow-600"
//       : value > 0
//       ? "text-red-600"
//       : "";

//   const getSignalColor = (value: number) =>
//     value > 31
//       ? "text-yellow-400"
//       : value > 25
//       ? "text-green-600"
//       : value > 20
//       ? "text-green-600"
//       : value > 13
//       ? "text-yellow-600"
//       : value > 0
//       ? "text-red-600"
//       : "";

//   const getBackupColor = (value: number) =>
//     value > 5.5
//       ? "text-yellow-400"
//       : value > 4
//       ? "text-blue-600"
//       : value > 3.5
//       ? "text-green-600"
//       : value > 3.3
//       ? "text-yellow-600"
//       : value > 0.5
//       ? "text-red-600"
//       : value > 0
//       ? "text-red-600"
//       : "";

//   const getTempColor = (value: number | null) =>
//     value == null
//       ? ""
//       : value >= 65
//       ? "text-yellow-400"
//       : value >= 35
//       ? "text-red-600"
//       : value >= 20
//       ? "text-orange-500"
//       : value >= 0
//       ? "text-green-600"
//       : "text-blue-600";

//   if (isMobile) {
//     return (
//       <div className="flex items-center justify-around text-center font-bold">
//         <span className={getBatteryColor(battery)}>
//           {battery !== 0 ? battery : "__"}
//         </span>
//         <span className="p-1">|</span>
//         <span className={getSignalColor(signal)}>
//           {signal !== 0 ? signal : "__"}
//         </span>
//         <span className="p-1">|</span>
//         <span className={getBackupColor(backupBattery)}>
//           {backupBattery !== 0 ? backupBattery : "__"}
//         </span>
//         {showTemper && (
//           <>
//             <span className="p-1">|</span>
//             <span className="text-orange-500">
//               {temperValue != null ? Math.round(temperValue) : "__"}
//             </span>
//           </>
//         )}
//       </div>
//     );
//   }

//   // Desktop: original icon + tooltip rendering
//   const renderBattery = () => {
//     const color = getBatteryColor(battery);
//     const isWarning = battery > 3.7; // condition for warning
//     const icon = isWarning ? (
//       <IoIosWarning />
//     ) : battery > 3.5 ? (
//       <MdBattery90 />
//     ) : battery > 3.3 ? (
//       <MdBattery60 />
//     ) : battery > 0 ? (
//       <MdBattery20 />
//     ) : (
//       <MdBatteryUnknown />
//     );

//     return (
//       <Tooltip label={`${battery !== 0 ? battery : "__"} ولت`} fontSize="sm">
//         <span
//           className={`mx-1 text-xl ${color} ${!isWarning ? "rotate-90" : ""}`}
//         >
//           {icon}
//         </span>
//       </Tooltip>
//     );
//   };

//   const renderSignal = () => {
//     const color = getSignalColor(signal);
//     const icon =
//       signal > 31 ? (
//         <IoIosWarning />
//       ) : signal > 25 ? (
//         <MdNetworkWifi />
//       ) : signal > 20 ? (
//         <MdNetworkWifi3Bar />
//       ) : signal > 13 ? (
//         <MdNetworkWifi2Bar />
//       ) : signal > 0 ? (
//         <MdNetworkWifi1Bar />
//       ) : (
//         <MdOutlineSignalWifiBad />
//       );
//     return (
//       <Tooltip label={`${signal !== 0 ? signal : "__"}`} fontSize="sm">
//         <span className={`mx-1 text-xl ${color}`}>{icon}</span>
//       </Tooltip>
//     );
//   };

//   const renderBackup = () => {
//     const color = getBackupColor(backupBattery);
//     const isWarning = backupBattery > 5.5;
//     const icon = isWarning ? (
//       <IoIosWarning />
//     ) : backupBattery > 4 ? (
//       <MdPower />
//     ) : backupBattery > 3.5 ? (
//       <MdBattery90 />
//     ) : backupBattery > 3.3 ? (
//       <MdBattery60 />
//     ) : backupBattery > 1.5 ? (
//       <MdBattery20 />
//     ) : backupBattery > 0 ? (
//       <MdPowerOff />
//     ) : (
//       <MdBatteryUnknown />
//     );

//     return (
//       <Tooltip
//         label={`${backupBattery !== 0 ? backupBattery : "__"} ولت`}
//         fontSize="sm"
//       >
//         <span
//           className={`mx-1 text-xl ${color} ${!isWarning ? "rotate-90" : ""}`}
//         >
//           {icon}
//         </span>
//       </Tooltip>
//     );
//   };

//   const renderTemperature = () => {
//     const color = getTempColor(temperValue);
//     const icon =
//       temperValue == null ? (
//         <MdDeviceThermostat />
//       ) : temperValue >= 65 ? (
//         <IoIosWarning />
//       ) : temperValue >= 35 ? (
//         <MdWhatshot />
//       ) : temperValue >= 20 ? (
//         <MdDeviceThermostat />
//       ) : temperValue >= 0 ? (
//         <MdDeviceThermostat />
//       ) : (
//         <MdAcUnit />
//       );

//     return (
//       <Tooltip label={`${temperValue ?? "__"} °C`} fontSize="sm">
//         <span className={`mx-1 text-xl ${color}`}>{icon}</span>
//       </Tooltip>
//     );
//   };

//   return (
//     <div className="flex items-center justify-around">
//       {renderBattery()}
//       {renderSignal()}
//       {renderBackup()}
//       {showTemper && renderTemperature()}
//     </div>
//   );
// };

export const renderCounterStatus = (
  status: LastConsumptionInfo,
  showTemper: boolean = false,
  isMobile: boolean = false,
  hasPressure: boolean = false
) => (
  <CounterStatusRenderer
    status={status}
    showTemper={showTemper}
    isMobile={isMobile}
    hasPressure={hasPressure}
  />
);

export const renderSelectData = (
  data: any[],
  selectDataType: "user" | "project" | "module" | "counter" | "tag" | "type"
) => {
  let selectData: DynamicOption[] = [];
  switch (selectDataType) {
    case "counter":
      let counters: DeviceObj[] = data;
      counters?.forEach((obj) => {
        selectData.push({
          label: obj.water_meter_name,
          value: obj.water_meter_serial,
        });
      });
      return selectData;
    case "module":
      let modules: ModuleObject[] = data;
      modules?.forEach((obj) => {
        selectData.push({
          label: obj.water_meter_module_name,
          value: obj.water_meter_module_id,
        });
      });
      return selectData;
    case "user":
      let users: UserObject[] = data;
      users?.forEach((user) => {
        selectData.push({
          value: user.user_id,
          label: `${user.user_name} ${user.user_lastname}`,
        });
      });
      return selectData;
    case "project":
      let projects: ProjectObject[] = data;
      projects?.forEach((project) => {
        selectData.push({
          value: project.water_meter_project_id,
          label: project.water_meter_project_name,
        });
      });
      return selectData;

    default:
      return selectData;
  }
};
export const renderSendingStatus = (sendingDate: string) => {
  // console.log(sendingDate);
  let sendDate = convertTZ(sendingDate, "Asia/Tehran").split(",")[0];
  let sendDateArr = sendDate.split("/"); //[month,day,year]
  let todayDateArr = getToday().format("YYYY/M/D").split("/"); //[year,month,day]
  let delay =
    (Number(todayDateArr[0]) - Number(sendDateArr[2])) * 365 +
    (Number(todayDateArr[1]) - Number(sendDateArr[0])) * 30 +
    (Number(todayDateArr[2]) - Number(sendDateArr[1]));
  return (
    <span
      className={`${
        !sendingDate
          ? "bg-yellow-600"
          : delay === 0
          ? " bg-green-500"
          : " bg-red-500"
      } rounded p-1 text-xs text-white `}
    >
      {!sendingDate
        ? "بدون داده"
        : delay === 0
        ? "به روز"
        : `عدم ارسال (${delay} روز)`}
    </span>
  );
};
export const renderUnit = (tag: string, isKilo: boolean) => {
  let unit = "";
  if (isKilo) {
    switch (tag) {
      case "آب":
        unit = "مترمکعب";
        break;
      case "برق":
        unit = "کیلووات";
        break;
      default:
        unit = "مترمکعب";
        break;
    }
  } else {
    switch (tag) {
      case "آب":
        unit = "لیتر";
        break;
      case "برق":
        unit = "وات";
        break;
      default:
        unit = "لیتر";
        break;
    }
  }
  return unit;
};
